import { motion } from "framer-motion";
import { ShieldCheck, SealCheck, Truck, ChatsCircle, WhatsappLogo, Money } from "@phosphor-icons/react";

const METHODS = ["Mercado Pago", "PayPal", "Tarjeta de crédito o débito (vía Mercado Pago o PayPal)", "Pago contra entrega en Xalapa"];

const CARDS = [
  {
    icon: ShieldCheck,
    title: "Pago protegido",
    text: "Paga con Mercado Pago o PayPal. Tus datos de tarjeta nunca pasan por nuestra página y, si tu pedido no llega, puedes solicitar un reembolso según las condiciones de cada plataforma.",
    link: {
      label: "Ver condiciones de Mercado Pago",
      href: "https://www.mercadopago.com.mx/ayuda/compra-protegida-compradores_23229",
    },
  },
  {
    icon: SealCheck,
    title: "Garantía de 1 año",
    text: "Todos nuestros productos incluyen 1 año de garantía. Si algo falla, escríbenos y lo resolvemos.",
    whatsapp: true,
  },
  {
    icon: Truck,
    title: "Envíos a todo México",
    text: "Envío a todo México: $99. Gratis en compras desde $1,399 MXN. Enviamos con FedEx, Estafeta, DHL y Mercado Libre. Tiempo de entrega: Veracruz y estados vecinos 1 a 3 días; resto de México 3 días; ejidos y zonas de difícil acceso 3 a 7 días.",
  },
  {
    icon: Money,
    title: "Pago contra entrega en Xalapa",
    text: "Si estás en Xalapa, pagas cuando recibes tu pedido. Pregúntanos por WhatsApp.",
    whatsapp: true,
  },
  {
    icon: ChatsCircle,
    title: "Atención humana",
    text: "Te atiende una persona, no un bot, antes y después de tu compra. Punto de distribución en Xalapa, Veracruz.",
  },
];

export const CompraSegura = () => {
  return (
    <section
      id="compra-segura"
      data-testid="compra-segura-section"
      className="py-28 lg:py-36 border-t border-black/10 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-10"
        >
          <h2 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418]">
            Compra segura
          </h2>
          <p className="text-black/55 text-sm mt-4">Paga como prefieras y recibe tu pedido con garantía</p>
        </motion.div>

        <motion.div
          data-testid="payment-methods"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="flex flex-wrap gap-2.5 mb-12"
        >
          {METHODS.map((m) => (
            <span key={m} className="text-xs text-black/70 bg-[#F4F5F6] border border-black/10 rounded-full px-4 py-2">
              {m}
            </span>
          ))}
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {CARDS.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.title}
                data-testid={`compra-segura-card-${i + 1}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 4) * 0.1 }}
                className="bg-white border border-black/10 rounded-xl p-7 flex flex-col gap-4 transition-shadow duration-300 hover:shadow-md"
              >
                <Icon size={28} weight="regular" className="text-[#FF5508]" />
                <h3 className="font-semibold text-lg text-[#111418]">{card.title}</h3>
                <p className="text-black/60 text-sm leading-relaxed">{card.text}</p>
                {card.link && (
                  <a
                    data-testid="compra-segura-condiciones-link"
                    href={card.link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto text-xs text-[#FF5508] underline underline-offset-4 hover:text-black transition-colors duration-300 w-fit"
                  >
                    {card.link.label}
                  </a>
                )}
                {card.whatsapp && (
                  <a
                    data-testid="compra-segura-whatsapp-button"
                    href="https://wa.me/5212284081782"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto inline-flex items-center gap-2 bg-[#25D366] text-white text-xs font-semibold px-4 py-2.5 rounded-full transition-colors duration-300 hover:bg-black w-fit"
                  >
                    <WhatsappLogo size={14} weight="fill" />
                    Escríbenos por WhatsApp
                  </a>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
